<ng-container [ngSwitch]="action">
  <ng-container *ngSwitchCase="'pause'">
    <h2 mat-dialog-title>Pause Dunning</h2>
    <form [formGroup]="formGroup" (submit)="pauseDunning()">
      <mat-dialog-content>
        <div class="dialog">
          Pause dunning until a specified date. After this date, dunning will resume as expected.
        </div>
        <mat-form-field>
          <input
            matInput
            [matDatepicker]="picker"
            [min]="minDate"
            placeholder="Pause dunning until"
            formControlName="pauseDunningUntil"
            required
          />
          <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
          <mat-error *ngIf="pauseDunningUntil.hasError('required')">required</mat-error>
        </mat-form-field>
      </mat-dialog-content>
      <mat-dialog-actions>
        <button mat-button mat-dialog-close>Cancel</button>
        <button mat-raised-button color="primary" type="submit" [disabled]="!formGroup.valid || loading">
          Pause Dunning
        </button>
      </mat-dialog-actions>
    </form>
  </ng-container>

  <ng-container *ngSwitchCase="'resume'">
    <h2 mat-dialog-title>Resume Dunning</h2>
    <mat-dialog-content class="dialog">
      <p>Are you sure you want to resume dunning?</p>
    </mat-dialog-content>
    <mat-dialog-actions>
      <button mat-button color="primary" mat-dialog-close>Cancel</button>
      <button mat-raised-button color="primary" (click)="resumeDunning()" [disabled]="loading">Resume Dunning</button>
    </mat-dialog-actions>
  </ng-container>
</ng-container>
